<template>
  <nav class="navbar navbar-expand-sm navbar-default">

    <div class="navbar-header">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-menu" aria-controls="main-menu" aria-expanded="false" aria-label="Toggle navigation" v-on:click="setMenuChange()">
        <i class="fa fa-bars"></i>
      </button>
      <a class="navbar-brand" href="#"><img class="logoheight" src="/img/logo.png" alt="Logo"></a>
      <a class="navbar-brand hidden" href="#"><img class="logoheight2" src="/img/logo.png" alt="Logo"></a>
    </div>

    <div id="main-menu" class="main-menu  navbar-collapse" v-bind:class="{'collapse': collapse}">
      <ul class="nav navbar-nav">


        <!--Mindenkinek-->
        <h3 class="menu-title hiddenX">{{ $t('LeftMenu.general') }}</h3><!-- /.menu-title -->
        <li class="">
          <router-link to="/dashboard" tag="li" class="nav-item"><a><i class="menu-icon fa fa-tachometer"></i>{{ $t('LeftMenu.dashboard') }}</a></router-link>
        </li>

        <h3 class="menu-title hiddenX">{{ $t('AminLeftMenu.admin') }}</h3><!-- /.menu-title -->
        <li class="">
        <router-link to="/users" tag="li" class="nav-item"><a><i class="menu-icon fa fa-user"></i>{{ $t('AminLeftMenu.users') }}</a></router-link>
        </li>




        <!--<template v-if="HelperRole.hasRights(state, [14],true)">-->
          <!--<h3 class="menu-title hiddenX">{{ $t('LeftMenu.invoicereconciler') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--</template>-->

        <hr>
        <!--<template v-if="HelperRole.hasRights(state, [15],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundnavrefresh" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud-download"></i>{{ $t('LeftMenu.invoiceinboundnavrefresh') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->


        <!--<template v-if="HelperRole.hasRights(state, [14],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/sbinvoiceinbounds" tag="li" class="nav-item"><a><i class="menu-icon fa fa-arrow-circle-down"></i>{{ $t('LeftMenu.sbinvoiceinbounds') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[16])">-->
          <!--<li class="">-->
            <!--<router-link to="/sbinvoiceinbound" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud-upload"></i>{{ $t('LeftMenu.invoiceinbound') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<hr>-->

        <!--uploader-->
        <!--<template v-if="HelperRole.hasRights(state, [15],[16])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceninboundnavrefresh" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud-download"></i>{{ $t('LeftMenu.invoiceninboundnavrefresh') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[16])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinbound" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud-upload"></i>{{ $t('LeftMenu.invoiceupload') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[16])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundsuploader" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud"></i>{{ $t('LeftMenu.invoiceinboundsuploader') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--&lt;!&ndash;owner&ndash;&gt;-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[17])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundsleader" tag="li" class="nav-item"><a><i class="menu-icon fa fa-briefcase"></i>{{ $t('LeftMenu.invoiceinboundsleader') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--&lt;!&ndash;finance&ndash;&gt;-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[18])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundsfinance" tag="li" class="nav-item"><a><i class="menu-icon fa fa-credit-card"></i>{{ $t('LeftMenu.invoiceinboundsfinance') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--accountant-->


        <!--<template v-if="HelperRole.hasRights(state, [15],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceoutboundnavrefresh" tag="li" class="nav-item"><a><i class="menu-icon fa fa-cloud-download"></i>{{ $t('LeftMenu.invoiceoutboundnavrefresh') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--Nincs hasnav-ra szűrés, mert külföld-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceoutbounds" tag="li" class="nav-item"><a><i class="menu-icon fa fa-arrow-circle-up"></i>{{ $t('LeftMenu.invoiceoutbounds') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->


        <!--<template v-if="HelperRole.hasRights(state, [14],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/otherincomeexpenses" tag="li" class="nav-item"><a><i class="menu-icon fa fa-paperclip"></i>{{ $t('LeftMenu.otherincomeexpenses') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/incomeexpensestatement" tag="li" class="nav-item"><a><i class="menu-icon fa fa-building-o"></i>{{ $t('LeftMenu.incomeexpensestatement') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/transferlist" tag="li" class="nav-item"><a><i class="menu-icon fa fa-money"></i>{{ $t('LeftMenu.transferlist') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[19])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundsaccountant" tag="li" class="nav-item"><a><i class="menu-icon fa fa-caret-square-o-down"></i>{{ $t('LeftMenu.invoiceinboundsaccountant') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [17],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/proformas" tag="li" class="nav-item"><a><i class="menu-icon fa fa-file-text-o"></i>{{ $t('LeftMenu.proforma') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [16],[16, 20])">-->
          <!--<li class="">-->
            <!--<router-link to="/contracts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-gavel"></i>{{ $t('LeftMenu.contract') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->


        <!--<template v-if="HelperRole.hasRights(state, [14],[19])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinboundexport" tag="li" class="nav-item"><a><i class="menu-icon fa fa-table"></i>{{ $t('LeftMenu.invoiceinboundexport') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="false && HelperRole.hasRights(state, [14],false)">-->
          <!--<li class="">-->
            <!--<router-link to="/invoiceinbounds" tag="li" class="nav-item"><a><i class="menu-icon fa fa-table"></i>{{ $t('LeftMenu.invoiceinbounds') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[19])">-->
          <!--<li class="">-->
            <!--<router-link to="/invoicelistaccountant" tag="li" class="nav-item"><a><i class="menu-icon fa fa-book">&lt;!&ndash; fa-suitcase &ndash;&gt;</i>{{ $t('LeftMenu.invoicelistaccountant') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->


        <!--Admin-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[16,20])">-->
          <!--<h3 class="menu-title hiddenX">{{ $t('LeftMenu.admin') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[])">-->
          <!--<li class="">-->
            <!--<router-link to="/settings" tag="li" class="nav-item"><a><i class="menu-icon fa fa-gears"></i>{{ $t('LeftMenu.settings') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->

        <!--<template v-if="HelperRole.hasRights(state, [14],[16,20])">-->
          <!--<li class="">-->
            <!--<router-link to="/vats" tag="li" class="nav-item"><a><i class="menu-icon fa fa-hospital-o"></i>{{ $t('LeftMenu.vats') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[16,20])">-->
          <!--<li class="">-->
            <!--<router-link to="/businesspartners" tag="li" class="nav-item"><a><i class="menu-icon fa fa-briefcase"></i>{{ $t('LeftMenu.businesspartners') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->
        <!--<template v-if="HelperRole.hasRights(state, [14],[])">-->
          <!--<li class="">-->
            <!--<router-link to="/companydata" tag="li" class="nav-item"><a><i class="menu-icon fa fa-hospital-o"></i>{{ $t('LeftMenu.companydata') }}</a></router-link>-->
          <!--</li>-->
        <!--</template>-->




        <!--&lt;!&ndash;Admin&ndash;&gt;-->
        <!--<template v-if="state.user&&state.user.role=='ADMIN'">-->
          <!--<h3 class="menu-title hiddenX">{{ $t('LeftMenu.companyrolesettings') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->

          <!--<li v-if="false" class="">-->
            <!--&lt;!&ndash;Dashboard-ról éri el a cégét&ndash;&gt;-->
            <!--<router-link to="/companies" tag="li" class="nav-item"><a><i class="menu-icon fa fa-th"></i>{{ $t('LeftMenu.companies') }}</a></router-link>-->
          <!--</li>-->
          <!--<li class="">-->
            <!--<router-link to="/company2modul" tag="li" class="nav-item"><a><i class="menu-icon fa fa-list"></i>{{ $t('LeftMenu.company2modul') }}</a></router-link>-->
          <!--</li>-->
          <!--<li class="">-->
            <!--<router-link to="/user2company" tag="li" class="nav-item"><a><i class="menu-icon fa fa-user-md"></i>{{ $t('LeftMenu.user2company') }}</a></router-link>-->
          <!--</li>-->
          <!--&lt;!&ndash;<li class="">&ndash;&gt;-->
            <!--&lt;!&ndash;<router-link to="/user2role" tag="li" class="nav-item"><a><i class="menu-icon fa fa-th"></i>{{ $t('LeftMenu.user2role') }}</a></router-link>&ndash;&gt;-->
          <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, [1,10, 11],6)">-->
        <!--&lt;!&ndash;Eladások, Statisztikák&ndash;&gt;-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.sellstats') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selcharts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-bar-chart"></i>{{ $t('LeftMenu.selcharts') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([4, 5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selsells" tag="li" class="nav-item"><a><i class="menu-icon fa fa-shopping-cart"></i>{{ $t('LeftMenu.selsells') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, [1,10],4)">-->
        <!--&lt;!&ndash;Termékek&ndash;&gt;-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.products') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([2, 3, 4, 5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selproducts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-barcode"></i>{{ $t('LeftMenu.selproducts') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([2, 3, 4, 5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selproductcategories" tag="li" class="nav-item"><a><i class="menu-icon fa fa-inbox"></i>{{ $t('LeftMenu.selproductcategories') }}</a></router-link>-->
        <!--</li>-->

        <!--</template>-->


        <!--<template v-if="Helper.checkRolesAuto(this, 7,2)">-->
        <!--&lt;!&ndash;stockalert&ndash;&gt;-->
        <!--&lt;!&ndash;<div v-if="Helper.hasModuleRights(moduleRights, 7,[1,2,3,4,5,6,7,8,9,10])">&ndash;&gt;-->
        <!--&lt;!&ndash;{{Helper.hasModuleRights(this, 1, 1)}}&ndash;&gt;-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.stockalert') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/stostockalerts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-bar-chart"></i>{{ $t('LeftMenu.stockalerts') }}</a></router-link>-->
        <!--</li>-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</template>-->


        <!--&lt;!&ndash;<template v-if="Helper.checkRoles([8, 9, 10], user_role)">&ndash;&gt;-->
        <!--<template v-if="Helper.checkRolesAuto(this, [4,5,6,7,8,9,10,11],8)">-->
        <!--&lt;!&ndash;FELHŐ&ndash;&gt;-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.cloud') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([4, 5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/cloudusers" tag="li" class="nav-item"><a><i class="menu-icon fa fa-users"></i>{{ $t('LeftMenu.cloudusers') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([10], user_role)">-->
        <!--<router-link to="/selc" tag="li" class="nav-item"><a><i class="menu-icon fa fa-gears"></i>{{ $t('LeftMenu.selc') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->


        <!--&lt;!&ndash;telephelyek&ndash;&gt;-->
        <!--<template v-if="Helper.checkRolesAuto(this, [1,2,3,4,5,6,7,8,9,10,11],12)">-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.selstorestitle') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selstores" tag="li" class="nav-item"><a><i class="menu-icon fa fa-building-o"></i>{{ $t('LeftMenu.selstores') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, [3,6,1,12],13)">-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/crmbusinesspartners" tag="li" class="nav-item"><a><i class="menu-icon fa fa-briefcase"></i>{{ $t('LeftMenu.crmbusinesspartners') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/crmcontacts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-suitcase"></i>{{ $t('LeftMenu.crmcontacts') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, [1,3,6,8])">-->
        <!--&lt;!&ndash;1-es is benne van, így az eladó progiban kell majd a szállítólevél nyomtatáshoz&ndash;&gt;-->
        <!--&lt;!&ndash;Később kell a [3,6,8,11] -is a számla miatt, de csak a felhő számlázókor&ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/companydata" tag="li" class="nav-item"><a><i class="menu-icon fa fa-hospital-o"></i>{{ $t('LeftMenu.companydata') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, [3,6,8,11],14)">-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selvats" tag="li" class="nav-item"><a><i class="menu-icon fa fa-hospital-o"></i>{{ $t('LeftMenu.selvats') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->
        <!--&lt;!&ndash;user_role -> Ez az user tábla role- mezője&ndash;&gt;-->
        <!--&lt;!&ndash;partneruserroleId => ez az amit az user role-ú felhasználó adatlapján pipál6unk.. aljogosultságok&ndash;&gt;-->

        <!--&lt;!&ndash;checkRolesAuto(this, modul tábla azonosító , role tábla azonosító)&ndash;&gt;-->
        <!--&lt;!&ndash;checkRolesAuto(this, 3,1)               ha admin, és a 3-as modulhoz van joga a cégnek akkor ok,  ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 1-esnek és akkkor oké&ndash;&gt;-->
        <!--&lt;!&ndash;checkRolesAuto(this, [1,10],13)         Ha admin, és a 1, 10-es modulok valamelyikéhez van joga a cégnek akkor ok, ILLETVE ha user joga van akkor partneruserrole alapján kell lennie 13-esnek és akkkor oké&ndash;&gt;-->

        <!--&lt;!&ndash;checkRoles([5, 6, 7, 8, 9, 10], user_role)   a user_role benne van-e a felsoroltak között&ndash;&gt;-->

        <!--<template v-if="Helper.checkRolesAuto(this, 3,11)">-->
        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/offoffers" tag="li" class="nav-item"><a><i class="menu-icon fa fa-coffee"></i>{{ $t('LeftMenu.offoffers') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--&lt;!&ndash;<span class="text-white small">invoice-nak modul</span>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/invinvoices" tag="li" class="nav-item"><a><i class="menu-icon fa fa-file-text"></i>{{ $t('LeftMenu.invoice') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->


        <!--<template v-if="Helper.checkRolesAuto(this, 6,1)">-->
        <!--<h3 class="menu-title ">{{ $t('LeftMenu.stock') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->

        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/storevenues" tag="li" class="nav-item"><a><i class="menu-icon fa fa-caret-square-o-right"></i>{{ $t('LeftMenu.revenue') }}</a></router-link>-->
        <!--</li>-->

        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/stodeliverynotes" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.deliverynotes') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->

        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/stobuyerorders" tag="li" class="nav-item"><a><i class="menu-icon fa fa-caret-square-o-down"></i>{{ $t('LeftMenu.buyerorder') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/stoorders" tag="li" class="nav-item"><a><i class="menu-icon fa fa-caret-square-o-left"></i>{{ $t('LeftMenu.order') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/stodeliverynotes" tag="li" class="nav-item"><a><i class="menu-icon fa fa-caret-square-o-up"></i>{{ $t('LeftMenu.deliverynote') }}</a></router-link>-->
        <!--</li>-->


        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/crmbusinesspartner" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.crmbusinesspartner') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/crmcontacts" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.crmcontacts') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/crmcontact" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.crmcontact') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/crmaddresses" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.crmaddresses') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/crmaddress" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.crmaddress') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->

        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, 1,5)">-->
        <!--&lt;!&ndash;Selling&ndash;&gt;-->
        <!--&lt;!&ndash;<div v-if="Helper.hasModuleRights(moduleRights, 1,[4,5,6,7,8,9,10])">&ndash;&gt;-->
        <!--&lt;!&ndash;{{Helper.hasModuleRights(this, 1, 1)}}&ndash;&gt;-->
        <!--<h3 class="menu-title ">{{ $t('LeftMenu.selling') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selbuyers" tag="li" class="nav-item"><a><i class="menu-icon fa fa-credit-card"></i>{{ $t('LeftMenu.selbuyers') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/seldiscountchooses" tag="li" class="nav-item"><a><i class="menu-icon fa fa-money"></i>{{ $t('LeftMenu.seldiscountchoose') }}</a></router-link>-->
        <!--</li>-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/seldiscountbands" tag="li" class="nav-item"><a><i class="menu-icon fa fa-money"></i>{{ $t('LeftMenu.seldiscountbands') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selcontents" tag="li" class="nav-item"><a><i class="menu-icon fa fa-file-text-o"></i>{{ $t('LeftMenu.selcontents') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selworkstations" tag="li" class="nav-item"><a><i class="menu-icon fa fa-desktop"></i>{{ $t('LeftMenu.selworkstations') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/selsettings" tag="li" class="nav-item"><a><i class="menu-icon fa fa-gears"></i>{{ $t('LeftMenu.selsettings') }}</a></router-link>-->
        <!--</li>-->
        <!--&lt;!&ndash;<li class="" v-if="Helper.checkRoles([2, 3, 4, 5, 6, 7, 8, 9, 10], user_role)">&ndash;&gt;-->
        <!--&lt;!&ndash;<router-link to="/usermyprofile" tag="li" class="nav-item"><a><i class="menu-icon fa fa-user"></i>{{ $t('LeftMenu.usermyprofile') }}</a></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->

        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</template>-->
        <!--&lt;!&ndash;<span class="text-white">&ndash;&gt;-->


        <!--&lt;!&ndash;// users - sellers &ndash;&gt;-->
        <!--<template v-if="Helper.checkRolesAuto(this, 1,7)">-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.selusers') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([4, 5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/users" tag="li" class="nav-item"><a><i class="menu-icon fa fa-users"></i>{{ $t('LeftMenu.selusers') }}</a></router-link>-->
        <!--</li>-->
        <!--</template>-->

        <!--<template v-if="Helper.checkRolesAuto(this, 5,1)">-->
        <!--&lt;!&ndash;worworklogs&ndash;&gt;-->
        <!--&lt;!&ndash;<div v-if="Helper.hasModuleRights(moduleRights, 5,[1,2,3,4,5,6,7,8,9,10])">&ndash;&gt;-->
        <!--&lt;!&ndash;{{Helper.hasModuleRights(this, 1, 1)}}&ndash;&gt;-->
        <!--<h3 class="menu-title hidden">{{ $t('LeftMenu.worworklogs') }}</h3>&lt;!&ndash; /.menu-title &ndash;&gt;-->
        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/worworklogs" tag="li" class="nav-item"><a><i class="menu-icon fa fa-table"></i>{{ $t('LeftMenu.monthlylog') }}</a></router-link>-->
        <!--</li>-->
        <!--<li class="" v-if="Helper.checkRoles([2,3,5, 6, 7, 8, 9, 10], user_role)">-->
        <!--<router-link to="/wordaylogs" tag="li" class="nav-item"><a><i class="menu-icon fa fa-asterisk"></i>{{ $t('LeftMenu.wordaylogs') }}</a></router-link>-->
        <!--</li>-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</template>-->


      </ul>
    </div><!-- /.navbar-collapse -->
    <AppVersion/>
---    <ScrollTop/>---
  </nav>
</template>
<script>
  //  import { mapState } from 'vuex';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import AppVersion from '@/components/AppVersion';
  import ScrollTop from '@/components/ScrollTop';

  export default {
    name: 'LeftMenu',
    data(){
      return {
        Helper: Helper,
        HelperRole: HelperRole
//        moduleRights: []
//        , moduleRightsIds: []
        , collapse: true
//        , user_role: 0
//        ,
//        , moduleRights: moduleRights
//        , modd: false

        , user: {}
        , companymodules: []
        , usercompanies: []
        , userrolesforcompany: []
        , hasRole: false
        , hasCompany: false
        , state: {} // local copy of state. refresh by original state data change by stateHash watcher
        , stateHash: ""
        , hasnav: false
        , appVersion: ""

      }
    },

    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          this.handleRights();

//          modul.stateHash=modul.$store.state.stateHash;
        }
      },
//
//      "$store.state.user": function (newData, oldData) {
//        if (String(newData) !== "" && newData !== oldData) {
//          this.handleRights();
//        }
//      },
//      "$store.state.companymodules": function (newData, oldData) {
//        if (String(newData) !== "" && newData !== oldData) {
//          this.handleRights();
//        }
//      },
//      "$store.state.usercompanies": function (newData, oldData) {
//        if (String(newData) !== "" && newData !== oldData) {
//          this.handleRights();
//        }
//      },
//      "$store.state.userrolesforcompany": function (newData, oldData) {
//        if (String(newData) !== "" && newData !== oldData) {
//          this.handleRights();
//        }
//      },
    },
//
//    watch: {
//      moduleRights: function (newVal, oldVal) {
//        const modul = this;
//        if (Array.isArray(modul.moduleRights)) {
//          modul.moduleRightsIds = [];
//          modul.moduleRights.forEach(function (e, i) {
//            if (Number(e.id_rights) > 0) {
//              modul.moduleRightsIds.push(e.modulid)
//            }
//          })
//        }
//      },
//      '$store.state.user': function (newVal, oldVal) {
//        const modul = this;
//        const user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        modul.user_role = user_role;
//      },
//      '$store.state.moduleRights': function (newVal, oldVal) {
//        const modul = this;
//        modul.moduleRights = newVal;
//
//        if (Array.isArray(modul.moduleRights)) {
//          modul.moduleRightsIds = [];
//          modul.moduleRights.forEach(function (e, i) {
//            if (Number(e.id_rights) > 0) {
//              modul.moduleRightsIds.push(e.modulid)
//            }
//          })
//        }
//      },
//
//    },
    mounted() {
      const modul = this;
//      modul.moduleRights = modul.$store.state.moduleRights;
      modul.modd = false;
      this.handleRights();
    },
    methods: {


      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);

        modul.user = modul.$store.state.user;
        modul.companymodules = modul.$store.state.companymodules;
        modul.usercompanies = modul.$store.state.usercompanies;
        modul.userrolesforcompany = modul.$store.state.userrolesforcompany;

        modul.stateHash = modul.$store.state;

        if (modul.$store.state.user.role) {

        }
        if (modul.state && modul.state.settings) {
          modul.hasnav = (modul.state.settings.hasnav === "true");
        }
      },
      setMenuChange: function (e) {
        const modul = this;
        if (modul.collapse === true) {
          modul.collapse = false;
        } else {
          modul.collapse = true;
        }
      },
    },
    components: {
      AppVersion,
      ScrollTop,
    },
  };
</script>

<style scoped>
  .logoheight {
    height: 65px;
  }

  .logoheight2 {
    height: 30px;
  }

  aside.left-panel .navbar .navbar-header {
    min-height: 65px;
  }

  h3.menu-title.hidden {
    display: none;
  }
</style>

